var _rect, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHibikiCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#111110"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 90,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 90,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 90,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 90,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 90,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 110,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 110,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 110,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 110,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 110,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 130,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 130,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 130,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 130,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 130,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 150,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 150,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 150,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 150,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 150,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#4a7a3a",
    opacity: 0.8
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 155,
    fontFamily: "Georgia, serif",
    fontSize: 48,
    fill: "#fff",
    opacity: 0.08,
    fontStyle: "italic"
  }, "\u97FF")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 340,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.25,
    letterSpacing: 3
  }, "HIBIKI \xB7 GPT-2 124M")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 42,
    fontFamily: "Georgia, serif",
    fontSize: 9,
    fill: "#4a7a3a",
    letterSpacing: 4
  }, "ATTENTION IS ALL YOU NEED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibikiCover);
export default __webpack_public_path__ + "static/media/hibiki-cover.ca13c86e6eb2c746ce6565356104fee9.svg";
export { ForwardRef as ReactComponent };